import styled from "styled-components";
import {ReactNode} from "react";
import { ChevronRightRounded } from "@mui/icons-material";

const ListItemStyle = styled.div`
  padding: 1rem;
  background: white;
  cursor: pointer;
  transition: .1s;
  font-size: 1.1rem;
  font-weight: 600;
  
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    background: #f5f5f5;
  }
`;

export default function ListItem(props: {children: ReactNode, onClick?: () => void}) {
    return <ListItemStyle onClick={props.onClick}>
        <div>
            {props.children}
        </div>
        {props.onClick && <div>
            <ChevronRightRounded />
        </div>}
    </ListItemStyle>
}